import { UilCheckCircle, UilTimesCircle } from "@iconscout/react-unicons"
import React from "react"

const Toast = ({ title, message, type }) => {
  return (
    <div className={`c-toast ${type}`}>
      {type === "success" && <UilCheckCircle />}
      {type === "error" && <UilTimesCircle />}
      <div className="content">
        {title && <div className="title">{title}</div>}
        {message && <div className="message">{message}</div>}
      </div>
    </div>
  )
}

export default Toast
